import React from "react";
import { useNavigate } from "react-router-dom";

// material import
import { Grid2, Box, Button } from "@mui/material";

// project import
import Logo from "../assets/suwa-arana-logo-white.png";
import ICTLogo from "../assets/ICT-logo.jpg";

const Header2 = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    window.location.href = "https://suwaarana.org/";
  };

  const handleICTRedirect = () => {
    window.location.href = "https://indiracancertrust.org/";
  };

  //   const handleLogin = () => {
  //     navigate("/login");
  //   };

  return (
    <Box>
      <Grid2 item size={{ xs: 12 }} sx={{ height: 44 }} />
      <Grid2 container justifyContent="center">
        <Grid2
          item
          size={{ xs: 8.2 }}
          sx={{ mt: 4, display: "flex", justifyContent: "space-between" }}
        >
          <Box
            onClick={handleRedirect}
            sx={{
              bgcolor: "#8B2757",
              width: 125,
              height: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img
              src={Logo}
              alt="Suwa Arana Logo"
              style={{ maxWidth: "100%", height: "84%" }}
            />
          </Box>
          <Box
            onClick={handleICTRedirect}
            sx={{
              width: 125,
              height: 120,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <img src={ICTLogo} style={{ maxWidth: "100%", height: "90%" }} />
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};

export default Header2;
